import { isTemplateCustomType, toast } from 'react-common'
import { useTranslation } from 'react-i18next'
import { CertificateRecord } from '@/api/models/certificate-record'
import { captureException } from '@/utils/sentryUtils'

export const useShareCertificate = (certificateRecord?: CertificateRecord | null) => {
  const { t } = useTranslation()

  return async () => {
    try {
      if (!certificateRecord) {
        captureException(new Error('No certificate record'))
        return
      }

      if (isTemplateCustomType(certificateRecord.certificateTemplate)) {
        await navigator.clipboard.writeText(
          `${window.location.origin}/learn/certificate/${certificateRecord.certificateNumber}`,
        )
      } else if (certificateRecord.externalUrl) {
        await navigator.clipboard.writeText(certificateRecord.externalUrl)
      } else {
        throw new Error('No external url')
      }

      toast.success(t('courseDetails.certificates.linkCopied'))
    } catch (error) {
      toast.critical(t('courseDetails.certificates.linkCouldNotBeCopied'))
      captureException(error)
    }
  }
}
